import { timeoutDefaultValue } from '@gik/core/constants';
import { appChannel, eventThankYouSent } from '@gik/core/eventbus/EventBus';
import { ModalButtonFooter } from '@gik/ui/Modal';
import type { UIGenericDialogOptions } from '@gik/ui/UIManager';
import { UI } from '@gik/ui/UIManager';
import React from 'react';
import type { ThankYouFormProps } from '../components/ThankYouForm/ThankYouForm';
import { ThankYouFormWrapper } from '../components/ThankYouForm/ThankYouFormWrapper';
import { GiftThankYouFormWrapper } from '@gik/user-profile/components/Wallet/GiftSendThankYouFormWrapper';
import { Analytics } from '@gik/analytics';
import { AnalyticsEvents } from '@gik/analytics/utils/Events';

export type openThankYouFormModalProps = {
  inkindRouteId?: string;
  options?: UIGenericDialogOptions;
};

export function openThankYouFormModal(props: ThankYouFormProps, modalProps: openThankYouFormModalProps = {}) {
  const { inkindRouteId, options } = modalProps;

  // strip out url parameters that were used to open this modal
  history.pushState({}, document.title, window.location.pathname);

  return UI.dialog(
    ({ close, footerRef }) => {
      return (
        <ThankYouFormWrapper
          buttonsPortal={footerRef}
          {...props}
          onSuccess={() => {
            setTimeout(() => {
              // publish a thank you sent success event
              appChannel.publish(eventThankYouSent);
            }, timeoutDefaultValue);
            close(true);
          }}
          inkindRouteId={inkindRouteId}
        />
      );
    },

    {
      title: 'Send Thank You Email',
      closable: true,
      autowidth: true,
      shouldCloseOnOverlayClick: false,
      className: 'gik-thank-you-form-modal',
      footer: <ModalButtonFooter centeredButtons={false} />,
      modalProps: {
        allowIntercom: true,
      },
      ...options,
    }
  );
}

export function openGiftThankYouFormModal(
  giftUuid: string,
  customerId: string,
  props: ThankYouFormProps,
  modalProps: openThankYouFormModalProps = {}
) {
  const { inkindRouteId, options } = modalProps;

  // strip out url parameters that were used to open this modal
  history.pushState({}, document.title, window.location.pathname);

  Analytics.fireEvent(AnalyticsEvents.WalletSendThankYouClicked, {
    customerId,
  });

  return UI.dialog(
    ({ close, footerRef }) => {
      return (
        <GiftThankYouFormWrapper
          giftUuid={giftUuid}
          customerId={customerId}
          buttonsPortal={footerRef}
          {...props}
          onSuccess={() => {
            setTimeout(() => {
              Analytics.fireEvent(AnalyticsEvents.WalletSendThankYouSent, {
                customerId,
              });

              // publish a thank you sent success event
              appChannel.publish(eventThankYouSent);
            }, timeoutDefaultValue);
            close(true);
          }}
          inkindRouteId={inkindRouteId}
        />
      );
    },

    {
      title: 'Send Thank You Email',
      closable: true,
      autowidth: true,
      shouldCloseOnOverlayClick: false,
      className: 'gik-thank-you-form-modal',
      footer: <ModalButtonFooter centeredButtons={false} />,
      modalProps: {
        allowIntercom: true,
      },
      onAfterClose: () => {
        Analytics.fireEvent(AnalyticsEvents.WalledThankYouModalClosed, {
          customerId,
        });
      },
      ...options,
    }
  );
}
